module.exports = __webpack_public_path__ + "media/images/design/common/images/btn_subsidy-7479b70fa7cce21de8b81d5a5591a86b.jpg";